import {
  faHeadset,
  faScrewdriverWrench,
  faUser,
  faUserCheck,
  faUserLock,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";

export const roles = [
  { index: 1, label: "Administrateur", icon: faScrewdriverWrench, color: "danger" },
  { index: 2, label: "Manager", icon: faUserTie, color: "warning" },
  { index: 3, label: "Guide", icon: faHeadset, color: "success" },
  { index: 4, label: "Référent", icon: faUserTie, color: "info" },
  { index: 5, label: "Utilisateur", icon: faUser, color: "primary" },
];

export const stats = [
  { index: true, label: "Actif", color: "success", icon: faUserCheck },
  { index: false, label: "Inactif", color: "danger", icon: faUserLock },
];
